import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/cnam-preset';

export const initialState = {
  ...resourceState,
};

export default resourceReducerFactory(initialState, types);
